import React, {useEffect, useRef, useState} from 'react';
import {Breadcrumbs} from "@mui/material";
import {addAndFormat, diffInDays, diffInMonths, isAfter, isFuture} from "@/shared/lib/date";
import useWithStore from "@/Hooks/useWithStore";
import BaseLayout from "@/Layouts/BaseLayout";
import Link from "@/Layouts/Link";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import reachGoalGA from "@/Helpers/ReachGoalGA";
import Svg from "@/Components/Svg";
import {Error} from "@/Components/Error";
import {scrollToElement} from "@/Helpers/Function";
import '@/Pages/VozvratTovara/scss/index.scss';

const scrollStyle = {scrollMargin: '100px'};

const VozvratTovara = (props) => {
    const {mobileApp = false} = props;
    // Запоминаем какой пункт нужно развернуть если пройден опросник
    let staticStepsStateItem = '';

    const staticStepsOneRef = useRef(null);
    const staticStepsTwoRef = useRef(null);
    const staticStepsThreeRef = useRef(null);

    const [staticStepsState, setStaticStepsState] = useState({
        one: false,
        two: false,
        three: false,
    });

    const toggleStaticSteps = (value) => {
        setStaticStepsState(state => ({...state, [value]: !staticStepsState[value]}));
    };

    const [dateInput, setDateInput] = useState('');
    const [moreFlag, setMoreFlag] = useState(false);
    const [errorDateInput, setErrorDateInput] = useState('');
    const [resultAnswers, setResultAnswers] = useState({
        answer_1: '',
        answer_2: '',
        answer_3: '',
    });

    useEffect(() => {
        let newState = {
            one: false,
            two: false,
            three: false,
        };
        if (staticStepsStateItem !== '') {
            newState = {...newState, [staticStepsStateItem]: true};
            setStaticStepsState(newState);
        }
    }, [resultAnswers]);

    const [step, setSteps] = useState(1);

    const nextStep = (key, answer) => {
        const nextStep = step + 1;
        if (nextStep < 5) {
            setSteps(nextStep);
        }

        setResultAnswers(state => ({...state, [key]: answer}));
    };

    const backStep = (key) => {
        const backStep = step - 1;
        if (backStep > 0) {
            setSteps(backStep);
        }

        setResultAnswers(state => ({...state, [key]: ''}));
    };

    /**
     * Обработчик ввода даты
     * @param event
     */
    const handleDateChange = (event) => {
        setDateInput(event.target.value);
    };

    const nextDate = (key) => {
        if (isValidDate(dateInput)) {
            setResultAnswers(state => ({...state, [key]: dateInput}));
            setSteps(step + 1);
            setErrorDateInput('');
        } else {
            setErrorDateInput('Вы ввели некорректную дату!');
        }
    };

    const isValidDate = (dateString) => {
        // Проверяем, что введенная строка имеет формат YYYY-MM-DD
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
        if (!dateRegex.test(dateString)) return false;

        // Проверяем, что год полностью и корректно введен и проверяем что дата не в будущем
        const year = parseInt(dateString.substring(0, 4), 10);
        return (
            !isNaN(year) &&
            isAfter(dateString, '2004-06-08') &&
            !isFuture(dateString)
        );
    };

    const moreDetailedChange = (ref) => {
        const options = {block: "start", inline: "center", behavior: "smooth"};
        scrollToElement(ref.current, options);
    };

    const ResultQuiz = () => {
        if (resultAnswers.answer_2 === '' && resultAnswers.answer_3 === '') {
            return null;
        }
        const result = [];
        let key = '';
        if (resultAnswers.answer_2 === 'ПМ') {
            key = 'answer_2';
            result.push(
                <p className={`returnProduct-quiz__resultText`} key={1}>
                    Пожалуйста, обратитесь в магазин, в котором вы приобретали украшение.
                </p>
            )
        } else {
            if (resultAnswers.answer_1 === 'ДА') {
                if (resultAnswers.answer_2 === 'ФМ') {
                    key = 'answer_2';
                    result.push(
                        <p className={`returnProduct-quiz__resultText`} key={2}>
                            В соответствии с пунктом 9 Перечня, утв. Постановлением Правительства РФ от
                            31.12.2020 № 2463, ювелирные изделия надлежащего качества, приобретенные в розничном
                            магазине с возможностью оценить их индивидуальные свойства, возврату и обмену не подлежат.
                        </p>
                    )
                } else {
                    if (resultAnswers.answer_3 === '') {
                        return null;
                    }

                    key = 'answer_3';
                    const daysDifference = diffInDays(new Date(), resultAnswers.answer_3);
                    const finalDate = addAndFormat(resultAnswers.answer_3, {days: 7});
                    if (daysDifference > 7) {
                        result.push(
                            <p className={`returnProduct-quiz__resultText`} key={3}>
                                В соответствии с пунктом 4 статьи 26.1. Закона РФ "О защите прав
                                потребителей" от 07.02.1992 № 2300-I, по истечении семи дней с момента получения
                                украшения вы не вправе отказаться от товара надлежащего качества.
                            </p>
                        )
                    } else {
                        staticStepsStateItem = 'one';
                        result.push(
                            <p className={`returnProduct-quiz__resultText`} key={4}>
                                Вы можете вернуть или обменять украшение до {finalDate} года. Пожалуйста, ознакомьтесь с
                                правилами возврата и обмена изделий надлежащего
                                качества. <span className={`moreDetailed`}
                                                onClick={() => moreDetailedChange(staticStepsOneRef)}>Подробнее</span>
                            </p>
                        )
                    }
                }
            } else {
                if (resultAnswers.answer_3 === '') {
                    return null;
                }

                const monthDifference = diffInMonths(new Date(), resultAnswers.answer_3);
                const finalDate = addAndFormat(resultAnswers.answer_3, {months: 6});
                key = 'answer_3';
                if (monthDifference > 6) {
                    staticStepsStateItem = 'three';
                    result.push(
                        <p className={`returnProduct-quiz__resultText`} key={5}>
                            Нами установлен гарантийный срок на украшения – 6 месяцев со дня продажи. Этот
                            срок истек, но мы могли бы предложить вам отремонтировать украшение
                            платно. <span className={`moreDetailed`}
                                          onClick={() => moreDetailedChange(staticStepsThreeRef)}>Подробнее</span>
                        </p>
                    )
                } else {
                    if (resultAnswers.answer_2 === 'ФМ') {
                        result.push(
                            <p className={`returnProduct-quiz__resultText`} key={6}>
                                Вы можете вернуть нам украшение до {finalDate} года. Необходимо прийти в фирменный
                                ювелирный магазин PLATINA, в котором приобреталось украшение, с товаром, чеком и
                                паспортом и оформить возврат
                            </p>
                        )
                    } else {
                        staticStepsStateItem = 'two';
                        result.push(
                            <p className={`returnProduct-quiz__resultText`} key={7}>
                                Вы можете вернуть нам украшение до {finalDate} года. Пожалуйста, ознакомьтесь с
                                правилами возврата изделий ненадлежащего
                                качества. <span className={`moreDetailed`}
                                                onClick={() => moreDetailedChange(staticStepsTwoRef)}>Подробнее</span>
                            </p>
                        )
                    }
                }
            }
        }

        return <div className={`returnProduct-quiz`} key={1}>
            <div className={`returnProduct-quiz returnProduct-quiz__back`}>
                <p className={`quizButton quizButton__back`}
                   onClick={() => backStep(key)}>
                    Назад
                </p>
            </div>
            <div className={`returnProduct-quiz__content`}>
                {result}
            </div>
        </div>;
    };

    return <BaseLayout {...props}>
        <section className={`section`}>
            {!mobileApp && (
                <div className={`breadcrumbs`}>
                    <div className={`container`}>
                        <Breadcrumbs maxItems={2} itemsAfterCollapse={2}>
                            <Link className={`breadcrumbs__link`} href={`/`}>
                                Главная
                            </Link>
                            <p className={`breadcrumbs__text`}>
                                Возврат товара
                            </p>
                        </Breadcrumbs>
                    </div>
                </div>
            )}
            <div className={`container`}>
                <h1 className={`h1`}>Возврат товара</h1>
            </div>
            <div className={`returnProduct`}>
                <div className={`returnProduct__bgColorGray`}>
                    <div className={`container`}>
                        <div className={`returnProduct-main`}>
                            <div className={`returnProduct-main__content`}>
                                <p className={`returnProduct-main__text`}>
                                    Украшение не подошло, обнаружился дефект, требуется чистка или ремонт – эти ситуации
                                    часто вызывают множество вопросов, а то и попросту ставят в
                                    тупик. <span className={`bold`}> Мы сделали возврат, обмен и ремонт украшений
                                    максимально простыми и комфортными для вас.</span> Теперь
                                    необязательно заполнять множество бланков – достаточно оформить одну электронную
                                    форму в личном кабинете. В любом месте, тогда, когда вам
                                    удобно. Возврат – это просто!
                                </p>
                            </div>
                            <div className={`returnProduct-main__banner`}>
                                <picture>
                                    <source type={`image/webp`}
                                            srcSet={`/storage/img/returnProduct/return_product_banner.webp`}
                                    />
                                    <img src={`/storage/img/returnProduct/return_product_banner.png`}
                                         alt={`deliveryBanner`}
                                         title={`deliveryBanner`}
                                         loading={`lazy`}
                                    />
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`container`}>
                    <p className={`returnProduct-footnoteText`}>
                        Пожалуйста, ответьте на несколько вопросов, чтобы мы помогли вам определить возможность
                        возврата, обмена или ремонта:
                    </p>
                    {step === 1 && (
                        <div className={`returnProduct-quiz`}>
                            <div className={`returnProduct-quiz__content returnProduct-quiz__content_first`}>
                                <p className={`returnProduct-quiz__question`}>
                                    Ваше украшение исправно?
                                </p>
                                <div className={`returnProduct-quiz__answerContainer`}>
                                    <p className={`quizButton quizButton__two`}
                                       onClick={() => nextStep('answer_1', 'ДА')}>
                                        Да
                                    </p>
                                    <p className={`quizButton quizButton__two`}
                                       onClick={() => nextStep('answer_1', 'НЕТ')}>
                                        Нет
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    {step === 2 && (
                        <div className={`returnProduct-quiz`}>
                            <div className={`returnProduct-quiz returnProduct-quiz__back`}>
                                <p className={`quizButton quizButton__back`}
                                   onClick={() => backStep('answer_1')}>
                                    Назад
                                </p>
                            </div>
                            <div className={`returnProduct-quiz__content`}>
                                <p className={`returnProduct-quiz__question`}>
                                    Каким образом вы приобрели украшение?
                                </p>
                                <div className={`returnProduct-quiz__answerContainer`}>
                                    <p className={`quizButton quizButton__three`}
                                       onClick={() => nextStep('answer_2', 'ИМ')}>
                                        Заказ через интернет-магазин PLATINA
                                    </p>
                                    <p className={`quizButton quizButton__three`}
                                       onClick={() => nextStep('answer_2', 'ФМ')}>
                                        Покупка в фирменном магазине PLATINA
                                    </p>
                                    <p className={`quizButton quizButton__three`}
                                       onClick={() => nextStep('answer_2', 'ПМ')}>
                                        Покупка в магазине наших партнеров
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    {step === 3 && (resultAnswers.answer_2 === 'ИМ' || (resultAnswers.answer_2 === 'ФМ' && resultAnswers.answer_1 === 'НЕТ')) && (
                        <div className={`returnProduct-quiz`}>
                            <div className={`returnProduct-quiz returnProduct-quiz__back`}>
                                <p className={`quizButton quizButton__back`}
                                   onClick={() => backStep('answer_2')}>
                                    Назад
                                </p>
                            </div>
                            <div className={`returnProduct-quiz__content`}>
                                <p className={`returnProduct-quiz__question`}>
                                    {resultAnswers.answer_2 === 'ИМ' ? ' Когда вы получили ваш заказ?' : ' Когда была совершена покупка?'}
                                </p>
                                <div className={`returnProduct-quiz__answerContainer`}>
                                    <div className={`form form__returnProductQuiz`}>
                                        <div className={`form__itemNew_returnProductQuiz`}>
                                            <input
                                                name={`date`}
                                                type={`date`}
                                                placeholder={`Дата *`}
                                                value={dateInput}
                                                onChange={handleDateChange}
                                                className={`text-inputNew text-inputNew__returnProductQuiz`}
                                            />
                                            <label className={`text-labelNew`}>Дата *</label>
                                        </div>
                                        <p className={`quizButton quizButton__nextDate`}
                                           onClick={() => nextDate('answer_3')}>
                                            Далее
                                        </p>
                                    </div>
                                    <Error message={errorDateInput} className={`errorDateMessage`} />
                                </div>
                            </div>
                        </div>
                    )}
                    <ResultQuiz />
                </div>
                <div className={`container`} ref={staticStepsOneRef} style={scrollStyle}>
                    <p className={`returnProduct__title${staticStepsState.one ? ' visible' : ''}`}
                       onClick={() => toggleStaticSteps('one')}>
                        Возврат и обмен изделий надлежащего качества
                    </p>
                </div>
                <div className={`returnProduct__bgColorGray`}>
                    <div className={`container`}>
                        <div className={`returnProduct__staticStepsContainer${staticStepsState.one ? ' visible' : ''}`}>
                            <div className={`returnProduct__description`}>
                                Украшение не подошло, не понравилось, или вы передумали? При дистанционном способе
                                продажи вы имеете право <span className={`bold`}> вернуть или обменять товар надлежащего качества
                                в течение 7 дней </span> с момента получения заказа при условии сохранения товарного
                                вида и опломбированного ярлыка.<span className={`bold`}> Для этого необходимо:</span>
                            </div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 1:</p>
                                        <p className={`staticStep__name`}>
                                            <span className={`bold`}>
                                                Оформите заявку на возврат или обмен товара в личном кабинете
                                            </span>
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepOne`}
                                             className={`svg__returnProductStaticStepOne`} />
                                    </p>
                                </div>
                                {!mobileApp ? (
                                        <p className={`staticStep__footnoteText`}>
                                            В <Link href={`/home?profile=refunds`}
                                                    className={`link link__bold link__returnProduct`}>
                                            личном кабинете в разделе «Возвраты»
                                        </Link> заполните заявку на возврат, обмен или ремонт и отправьие ее нам.
                                        </p>
                                    )
                                    :
                                    (
                                        <p className={`staticStep__footnoteText`}>
                                            В личном кабинете в разделе «Возвраты» заполните заявку на возврат, обмен
                                            или ремонт и отправьие ее нам.
                                        </p>
                                    )}
                            </div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 2:</p>
                                        <p className={`staticStep__name`}>
                                            В течение <span className={`bold`}> 3-х рабочих дней </span> ваша заявка
                                            будет рассмотрена, по ней будет принято решение
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepTwo`}
                                             className={`svg__returnProductStaticStepTwo`} />
                                    </p>
                                </div>
                            </div>
                            <div className={`returnProduct__percentageIndent`}></div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 3:</p>
                                        <p className={`staticStep__name`}>
                                            После того, как заявка будет принята, необходимо
                                            <span className={`bold`}>  направить украшение </span>курьерской службой,
                                            почтой или иным способом нам <span className={`bold`}> на завод или
                                                принести в один из фирменных магазинов PLATINA
                                            </span>
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepThree`}
                                             className={`svg__returnProductStaticStepThree`} />
                                    </p>
                                </div>
                            </div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 4:</p>
                                        <p className={`staticStep__name`}>
                                            <span className={`bold`}>
                                                В срок не позднее 10 дней
                                            </span> с момента получения нами товара на складе
                                            завода-изготовителя, <span className={`bold`}> мы вернем вам денежную
                                                сумму,</span> уплаченную за товар, по реквизитам, указанным в заявке на
                                            возврат
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepFour`}
                                             className={`svg__returnProductStaticStepFour`} />
                                    </p>
                                </div>
                                <p className={`staticStep__footnoteText`}>
                                    Возврат денежных средств производится на ваш банковский счёт или карту в течение
                                    5-30
                                    рабочих дней (срок зависит от банка, в котором открыт ваш расчетный счет).
                                </p>
                            </div>
                            <div className={`returnProduct__description`}>
                                Пожалуйста, <strong>следите за статусами заявки</strong> в личном кабинете. Все детали
                                обработки заявки вы можете увидеть, нажав кнопку <strong>«Подробнее»</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`container`} ref={staticStepsTwoRef} style={scrollStyle}>
                    <p className={`returnProduct__title${staticStepsState.two ? ' visible' : ''}`}
                       onClick={() => toggleStaticSteps('two')}>
                        Возврат или гарантийный ремонт изделий ненадлежащего качества
                    </p>
                </div>
                <div className={`returnProduct__bgColorGray`}>
                    <div className={`container`}>
                        <div className={`returnProduct__staticStepsContainer${staticStepsState.two ? ' visible' : ''}`}>
                            <div className={`returnProduct__description`}>
                                <span className={`bold`}>
                                    Мы изготавливаем украшения на собственном предприятии и уверены в их качестве,
                                </span> поэтому установили <span className={`bold`}>срок гарантийного
                                    обслуживания
                                </span> на весь товар интернет-магазина PLATINA – <span className={`bold`}>
                                    6 месяцев
                                </span> со дня приобретения. <span className={`bold`}>
                                    Если гарантийный случай все же возник, вам потребуется:
                                </span>
                            </div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 1:</p>
                                        <p className={`staticStep__name`}>
                                            <span className={`bold`}>
                                                Оформите заявку на возврат или ремонт товара в личном кабинете
                                            </span>
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepOne`}
                                             className={`svg__returnProductStaticStepOne`} />
                                    </p>
                                </div>
                                {!mobileApp ? (
                                    <p className={`staticStep__footnoteText`}>
                                        В <Link href={`/home?profile=refunds`}
                                                className={`link link__bold link__returnProduct`}>
                                        личном кабинете в разделе «Возвраты»
                                    </Link> заполните заявку на возврат, обмен или ремонт и отправьие ее нам.
                                    </p>
                                ) : (
                                    <p className={`staticStep__footnoteText`}>
                                        В личном кабинете в разделе «Возвраты» заполните заявку на возврат, обмен или
                                        ремонт и отправьие ее нам.
                                    </p>
                                )}
                            </div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 2:</p>
                                        <p className={`staticStep__name`}>
                                            В течение <strong>3-х рабочих дней</strong> ваша заявка будет рассмотрена,
                                            по ней будет принято решение
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepTwo`}
                                             className={`svg__returnProductStaticStepTwo`} />
                                    </p>
                                </div>
                            </div>
                            <div className={`returnProduct__percentageIndent`}></div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 3:</p>
                                        <p className={`staticStep__name`}>
                                            После того, как заявка будет принята, необходимо
                                            <span className={`bold`}>  направить украшение </span>курьерской службой,
                                            почтой или иным способом нам <span className={`bold`}> на завод или
                                                принести в один из фирменных магазинов PLATINA
                                            </span>
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepThree`}
                                             className={`svg__returnProductStaticStepThree`} />
                                    </p>
                                </div>
                            </div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 4:</p>
                                        <p className={`staticStep__name`}>
                                            При необходимости
                                            <span className={`bold`}> мы оставляем за собой право на проведение
                                                независимой экспертизы
                                            </span> для выявления причин и оснований возникновения дефекта и письменно
                                            уведомим вас о месте, дате, времени и результатах экспертизы по адресу,
                                            указанному в заявке на возврат. В случае проведения экспертизы по качеству
                                            товара срок возврата вам денежных средств может увеличиваться на количество
                                            дней проведения экспертизы
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepFive`}
                                             className={`svg__returnProductStaticStepFive`} />
                                    </p>
                                </div>
                            </div>
                            <div className={`returnProduct__percentageIndent`}></div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 5:</p>
                                        <p className={`staticStep__name`}>
                                            <span className={`bold`}>
                                                При гарантийном случае мы устраним недостатки товара своими силами и
                                                за свой счет либо вернем денежные средства.
                                            </span> В случае, не являющемся гарантийным, мы вернем вам предоставленный
                                            вами товар и направим письменный ответ на заявку. Расходы на
                                            доставку товара в таком случае относятся на покупателя
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepSeven`}
                                             className={`svg__returnProductStaticStepSeven`} />
                                    </p>
                                </div>
                            </div>
                            <div className={`returnProduct__description`}>
                                Пожалуйста, <strong>следите за статусами заявки</strong> в личном кабинете. Все детали
                                обработки заявки вы можете увидеть, нажав кнопку <strong>«Подробнее»</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`container`} ref={staticStepsThreeRef} style={scrollStyle}>
                    <p className={`returnProduct__title${staticStepsState.three ? ' visible' : ''}`}
                       onClick={() => toggleStaticSteps('three')}>
                        Негарантийный ремонт изделий
                    </p>
                </div>
                <div className={`returnProduct__bgColorGray`}>
                    <div className={`container`}>
                        <div
                            className={`returnProduct__staticStepsContainer${staticStepsState.three ? ' visible' : ''}`}>
                            <div className={`returnProduct__description`}>
                                Нами установлен<span
                                className={`bold`}> гарантийный срок на украшения – 6 месяцев</span> со дня продажи.
                                Если он истек, но украшению потребовался ремонт, мы можем оказать вам эту услугу
                                платно.<span className={`bold`}> Для негарантийного ремонта необходимо:</span>
                            </div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 1:</p>
                                        <p className={`staticStep__name`}>
                                            <span className={`bold`}>
                                                Оформите заявку на ремонт товара в личном кабинете
                                            </span>
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepOne`}
                                             className={`svg__returnProductStaticStepOne`} />
                                    </p>
                                </div>
                                {!mobileApp ? (
                                    <p className={`staticStep__footnoteText`}>
                                        В <Link href={`/home?profile=refunds`}
                                                className={`link link__bold link__returnProduct`}>
                                        личном кабинете в разделе «Возвраты»
                                    </Link> заполните заявку на возврат, обмен или ремонт и отправьие ее нам.
                                    </p>
                                ) : (
                                    <p className={`staticStep__footnoteText`}>
                                        В личном кабинете в разделе «Возвраты» заполните заявку на возврат, обмен или
                                        ремонт и отправьие ее нам.
                                    </p>
                                )}
                            </div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 2:</p>
                                        <p className={`staticStep__name`}>
                                            В течение <strong>3-х рабочих дней</strong> ваша заявка будет рассмотрена,
                                            по ней будет принято решение
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepTwo`}
                                             className={`svg__returnProductStaticStepTwo`} />
                                    </p>
                                </div>
                            </div>
                            <div className={`returnProduct__percentageIndent`}></div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 3:</p>
                                        <p className={`staticStep__name`}>
                                            После того, как заявка будет принята, необходимо
                                            <span className={`bold`}>  направить украшение </span>курьерской службой,
                                            почтой или иным способом нам <span className={`bold`}> на завод или
                                                принести в один из фирменных магазинов PLATINA
                                            </span>
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepThree`}
                                             className={`svg__returnProductStaticStepThree`} />
                                    </p>
                                </div>
                            </div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 4:</p>
                                        <p className={`staticStep__name`}>
                                            Специалисты завода-изготовителя проведут тщательный
                                            <span className={`bold`}> осмотр украшения, определят возможность и
                                                стоимость необходимого ремонта
                                            </span>
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepFive`}
                                             className={`svg__returnProductStaticStepFive`} />
                                    </p>
                                </div>
                            </div>
                            <div className={`returnProduct__percentageIndent`}></div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 5:</p>
                                        <p className={`staticStep__name`}>
                                            <span className={`bold`}>
                                                Менеджер пришлет вам договор на ремонт
                                            </span>
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepSix`}
                                             className={`svg__returnProductStaticStepSix`} />
                                    </p>
                                </div>
                            </div>
                            <div className={`staticStep`}>
                                <div className={`staticStep__mainContent`}>
                                    <div className={`staticStep__mainText`}>
                                        <p className={`staticStep__title`}>Шаг 6:</p>
                                        <p className={`staticStep__name`}>
                                            <span className={`bold`}>
                                                После оплаты
                                            </span>, в соответствии с договором, <span className={`bold`}>мы произведем
                                                 ремонт украшения и отправим его вам
                                            </span>
                                        </p>
                                    </div>
                                    <p className={`staticStep__icon`}>
                                        <Svg id={`returnProductStaticStepSeven`}
                                             className={`svg__returnProductStaticStepSeven`} />
                                    </p>
                                </div>
                            </div>
                            <div className={`returnProduct__description`}>
                                Пожалуйста, <strong>следите за статусами заявки</strong> в личном кабинете. Все детали
                                обработки заявки вы можете увидеть, нажав кнопку <strong>«Подробнее»</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`container`}>
                    <p className={`returnProduct-footnoteText`}>
                        Более подробно с условиями возврата товара можно ознакомиться в соответствующих разделах
                        <Link href={`/rule/dogovor-publichnoj-oferty`}
                              className={`link link__bold link__pdf`}>
                            &nbsp;договора оферты
                        </Link>.
                        {/*<a href={`/storage/docs/dogovor_publichnoy_oferti.pdf`}*/}
                        {/*   className={`link link__bold link__pdf`}*/}
                        {/*   target={`_blank`}>*/}
                        {/*    &nbsp;договора оферты.*/}
                        {/*</a>*/}
                    </p>
                    <div className={`returnProduct-footnoteContainer`}>
                        <div>
                            Если у вас остались вопросы, всегда рады ответить на них по номеру <span className={`bold`}>
                                горячей линии <a onClick={() => {
                            reachGoalYM('phone_click');
                            reachGoalGA('phone_click');
                        }}
                                                 href={`tel:+78003501595`}>
                                    8 800 350-15-95
                                </a>
                            </span>
                        </div>
                        <div>
                            или по телефону <span className={`bold`}>
                                <a onClick={() => {
                                    reachGoalYM('phone_click');
                                    reachGoalGA('phone_click');
                                }}
                                   href={`tel:+79109522022`}>
                                    8 910 952-20-22
                                </a> (Telegram).
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </BaseLayout>
};

export default useWithStore(VozvratTovara);


